export enum PageType {
  AHAVA_WORDPRESS = 'AHAVA_WORDPRESS',
  PRODUCT = 'PRODUCT',
  ABOUT = 'ABOUT',
  HOME = 'HOME',
  DEFAULT = 'DEFAULT',
  CART = 'CART',
  ADD_TO_CART_SUGGESTION = 'ADD_TO_CART_SUGGESTION',
  COLLECTION = 'COLLECTION',
}
